import { ApiProperty } from "@nestjs/swagger";
import { IsNotEmpty, IsOptional } from "class-validator";

export class StoreConsumptionItemsData {
    @ApiProperty()
    @IsNotEmpty()
    itemCategoryId: number;

    @ApiProperty()
    @IsNotEmpty()
    itemId: number;

    @ApiProperty()
    @IsNotEmpty()
    quantity: number;
    @ApiProperty()
    @IsNotEmpty()
    availableStock: number;

    @ApiProperty()
    @IsOptional()
    storeConsumptionItemsId?: number;

    @ApiProperty()
    @IsOptional()
    storeConsumptionId?: number;

    @ApiProperty()
    @IsOptional()
    stockType?: string;

    @ApiProperty()
    @IsOptional()
    isPreperationRequired?: string;

    

    /**
     * 
     * @param itemId 
     * @param storeConsumptionItemsId 
     * @param storeConsumptionId 
     */
    constructor(itemId: number, storeConsumptionItemsId?: number, storeConsumptionId?: number,stockType?:string,isPreperationRequired?:string){
        this.itemId = itemId; 
        this.storeConsumptionItemsId = storeConsumptionItemsId; 
        this.storeConsumptionId = storeConsumptionId; 
        this.stockType = stockType
        this.isPreperationRequired = isPreperationRequired
    }
}